import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DatepickerComponent} from './datepicker.component';
import {SharedModule} from 'src/app/shared/shared.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {ReactiveFormsModule} from '@angular/forms';
import {IconsModule} from 'src/app/icons/icons.module';


@NgModule({
  declarations: [
    DatepickerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    MatDatepickerModule,
    ReactiveFormsModule,

    IconsModule,
  ],
  exports: [
    DatepickerComponent
  ]
})
export class DatepickerModule {
}
